import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CookieModule } from '@laurentgoudet/ngx-cookie';
import { AUTH_CONFIG } from './auth.config';
import { AuthConfig } from './auth.interface';
import { Auth } from './auth.service';

@NgModule({
  imports: [HttpClientModule, CookieModule],
})
export class AuthModule {
  static initialize(config: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [Auth, { provide: AUTH_CONFIG, useValue: config }],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/auth/auth.module.ts